module.exports = __webpack_public_path__ + "twitter-rounded-de0b6d42aa3ad58c596b.svg";